import script from "./HrListDetailLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./HrListDetailLayout.vue?vue&type=script&setup=true&lang=js"

import "./HrListDetailLayout.vue?vue&type=style&index=0&id=bf8a097e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf8a097e"]])

export default __exports__